/** Task creator overlay tabs mapped to Features Manager catalog keys. */
export const TASK_CREATOR_TABS = [
  {
    catalogKey: 'personalGoals',
    fallbackKey: 'TaskCreatorOverlayComponent.personalGoals',
  },
  {
    catalogKey: 'externalEvaluation',
    fallbackKey: 'TaskCreatorOverlayComponent.mindset360',
  },
  {
    catalogKey: 'kssTracker',
    fallbackKey: 'TaskCreatorOverlayComponent.kssTracker',
  },
  {
    catalogKey: 'workshops',
    fallbackKey: 'TaskCreatorOverlayComponent.workshop',
  },
];

export const DEFAULT_TASK_CREATOR_TAB = 'personalGoals';

export const TASK_CREATOR_TAB_CATALOG_KEYS = TASK_CREATOR_TABS.map((t) => t.catalogKey);
